import {isEmpty} from "@/util/Helpers";


export const namespaced = true
const getDefaultState = () => {
    return {
        caption: []
    }
}
export const state = getDefaultState()

export const mutations = {
    SET_CAPTIONS(state, captions) {
        state.caption = captions
    },
    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}

export const actions = {
    setCaptions({commit}, captions) {
        commit('SET_CAPTIONS', captions)
    },

    resetState({commit}) {
        commit('RESET_STATE')
    },
}

export const getters = {
    getCaptions: (state) => !isEmpty(state.caption) ? state.caption : null,
}
